import { Fragment, memo } from 'react'
import { extendedStyles } from './styles'

type NotAvailablePosterProps = {
    showText: string
    details?: string
}

const NotAvailablePoster = memo(
    ({ showText, details }: NotAvailablePosterProps) => (
        <Fragment>
            <span css={extendedStyles}>{showText}</span>
            {!!details && (
                <Fragment>
                    <br />
                    <span>{details}</span>
                </Fragment>
            )}
        </Fragment>
    ),
)

export default NotAvailablePoster
